import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
// import { Button, Card, Flex, WhiteSpace, WingBlank, Result, Modal } from 'antd-mobile-v2'
import { Button, Card, Dialog, Result } from 'antd-mobile'
import { Header, Wrapper, Container } from '../../../components_renew/Layout'
import { YenSpan } from '../../../components_renew/common/YenSpan'
import { componentUpdateWithToast } from '../../../components_renew/HOC'
import { requestOrderListData, setOrderListRefresh } from '../../../actions/mallAction'
import { AddressButton } from '../../../components_renew/Address/AddressButton'
import { handleCatch } from '../../../utils'
import { withTranslation } from 'react-i18next'

let initData = {
  status: -1,
  trackingNumber: '',
  amount: 0,
  productList: []
}

@withTranslation()
@withRouter
@connect((state, props) => {
  let { orderId } = props.match.params
  let { common, mallOrderList } = state
  let { loading, errorMessage } = common
  let data = mallOrderList.data.all.find(item => item['orderId'] === orderId)
  let invalid = !Boolean(data)
  return {
    refresh: mallOrderList.refresh,
    loading,
    invalid,
    errorMessage,
    hasData: mallOrderList.data.all.length > 0,
    validTime: invalid ? '-' : window.moment(data.createdTime).add(24, 'h').format('M.D HH:mm:ss'),
    data: invalid ? initData : data
  }
})
@componentUpdateWithToast
class OrderDetails extends React.PureComponent {

  loading = false

  componentDidMount () {
    if (this.props.refresh || !this.props.hasData) {this.props.dispatch(requestOrderListData())}
  }

  render () {
    const { t, data, validTime } = this.props
    return <Container>
      <Header>{t('order.details')}</Header>
      <Wrapper>
        {
          `${data.status}` === '1'
            ? <Result className={'mb-4'}
                      status={'waiting'}
                      title={<div className={'text-sm'}>
                        <div>订单将于以下时间关闭</div>
                        <div>请及时付款</div>
                      </div>}
                      description={validTime}/>
            : null
        }
        <AddressButton addressId={'tag'} address={data.addressData}/>
        <Card className={'!rounded'}>
          <div className={'flex justify-between items-center h-8 border-b'}>
            <div className={'text-sm'}>{`${t('order.num')}： ${data.orderId ? data.orderId : ''}`}</div>
            <div className={'text-orange-400'}>{data.statusText}</div>
          </div>
          <div className={'p-4'}>
            {
              data.productList.map((item, index) => {
                return <div className={'flex mb-4'} key={index}>
                  <img className={'h-auto w-24'} src={item['imgSrc']} alt=""/>
                  <div className={'flex-auto ml-4'}>
                    <div className={'line-clamp-2 mb-4'}>
                      {item['name']}
                    </div>
                    <div className={'flex justify-between'}>
                      <YenSpan>{item['price']}</YenSpan>
                      <div className={'text-sm'} style={{ color: 'var(--adm-color-weak)' }}>
                        x {item['amount']}
                      </div>
                    </div>
                  </div>
                </div>
              })
            }
          </div>
          <div className={'flex justify-between items-center'} style={{ color: 'var(--adm-color-weak)' }}>
            <div className={'leading-2'}>{data.amount}件 {t('order.total')}: <YenSpan>{data.total}</YenSpan></div>
            <div>
              {this.renderButton(data.status)}
            </div>
          </div>
        </Card>
        <br/>
        {
          Number(data.status) > 1
            ? data.trackingNumber
              ? <div>
                <Result
                  icon={<div/>}
                  title={<div style={{ userSelect: 'text' }}>
                    {data.trackingNumber}
                  </div>}
                  description={data.logisticsCompany}
                />
                <br/>
                {data.status === '3'
                  ? <div>
                    <Button color={'primary'} block onClick={this.confirmOrder}>{t('order.confirm')}</Button>
                  </div> : null}
              </div>
              : <Result
                status={'waiting'}
                title={''}
                description={t('order.no_delivery_info')}
              />
            : null
        }
      </Wrapper>
    </Container>
  }

  renderButton = statusCode => {
    let s = `${statusCode}`
    let jsx = null
    const { t } = this.props
    switch (s) {
      case '1':
        // jsx = [
        //   <Button type={'ghost'} size={'small'} inline onClick={this.onOrderCancel}>取消订单</Button>,
        //   <Button type={'primary'} size={'small'} inline onClick={this.onOrderPay}>付款</Button>
        // ]
        jsx = <div>
          {/*todo 小屏下按钮会换行，得跟跟List里的按钮一同优化*/}
          <Button size={'mini'} onClick={this.onOrderCancel}>{t('order.cancel')}</Button>&nbsp;
          <Button color={'primary'} size={'mini'} onClick={this.onOrderPay}>{t('order.pay')}</Button>
        </div>
        break
      case '2':
      case '3':
        // jsx = <Button type={'ghost'} size={'small'} inline onClick={this.onOrderConfirm}>确认收货</Button>
        break
      default:
    }
    return jsx
  }

  // onResultClick = () => {
  //
  // }

  onOrderPay = () => {
    let { orderId } = this.props.data
    this.props.history.push(`${window.PATH.MALL_ORDER_PAY}/${orderId}`)
  }

  onOrderCancel = () => {
    if (this.loading) return
    // Dialog.alert('确定要取消订单吗？',
    //   '',
    //   [
    //     { text: '再想一想' },
    //     {
    //       text: '取消订单', onPress: () => {
    //         window.toast.show('加载中...')
    //         let { orderId } = this.props.match.params
    //         let config = { method: 'delete', url: window.API.Mall.cancelOrder(orderId) }
    //         window.axios.request(config).then(() => {
    //           this.props.dispatch(setOrderListRefresh())
    //           window.toast.success('订单已取消', 1, () => {this.props.history.goBack()})
    //         }).catch(handleCatch)
    //       }
    //     }
    //   ])
    Dialog.show({
      title: '确定要取消订单吗?',
      actions: [[{
        key: 'cancel',
        text: '再想一想'
      }, {
        key: 'confirm',
        text: '取消订单',
        onClick: () => {
          window.toast.show('加载中...')
          let { orderId } = this.props.match.params
          let config = { method: 'delete', url: window.API.Mall.cancelOrder(orderId) }
          window.axios.request(config).then(() => {
            this.props.dispatch(setOrderListRefresh())
            window.toast.success('订单已取消', 1, () => {this.props.history.goBack()})
          }).catch(handleCatch)
        }
      }]]
    })
  }

  confirmOrder = () => {
    // Dialog.alert('确认收货', '确认后订单将转为已完成状态', [
    //   { text: '取消' },
    //   { text: '确认', onPress: this.postConfirm }
    // ])
    Dialog.show({
      title: '确认收货',
      content: '确认后订单将转为已完成状态',
      actions: [[{
        key: 'cancel',
        text: '取消'
      }, {
        key: 'confirm',
        text: '确认',
        onPress: this.postConfirm
      }]]
    })
  }

  postConfirm = () => {
    window.toast.show('数据请求中')
    let { orderId } = this.props.data
    let config = { url: window.API.Delivery.confirmOrder(orderId) }
    window.axios.request(config)
      .then(() => {
        window.toast.hide()
        // Dialog.alert('确认收货', '订单已完成，即将返回订单列表',
        //   [{
        //     text: '返回', onPress: () => {
        //       this.props.dispatch(setOrderListRefresh())
        //       window.history.back()
        //     }
        //   }])
        Dialog.alert({
          title: '确认收货',
          content: '订单已完成，即将返回订单列表',
          confirmText: '返回',
          onConfirm: () => {
            this.props.dispatch(setOrderListRefresh())
          }
        }).then(() => {
          window.history.back()
        })
      })
      .catch(handleCatch)
  }

}

export { OrderDetails }
